import { createAction, props } from '@ngrx/store';
import { Item, Section, Translation } from './translations.model';

// fetch all
export const fetchRecords = createAction(
    '[Data] fetch records translations'
);
export const fetchRecordsSuccess = createAction(
    '[Data] fetch records translations success', 
    props<{ listData: Translation[], total: number }>()
);
export const fetchRecordsFail = createAction(
    '[Data] fetch records translations failure', 
    props<{ error: string }>()
);

// fetch form all
export const fetchFormRecords = createAction(
    '[Data] fetch form records translations',
    props<{ id: string }>()
);
export const fetchFormRecordsSuccess = createAction(
    '[Data] fetch form records translations success', 
    props<{ listFormData: Item[], total: number }>()
);
export const fetchFormRecordsFail = createAction(
    '[Data] fetch form records translations failure', 
    props<{ error: string }>()
);

// fetch one 
export const fetchSingleRecord = createAction(
    '[Data] fetch single record translations',
    props<{id: string, section: string | null}>()
);
export const fetchSingleRecordSuccess = createAction(
    '[Data] fetch single record translations success', 
    props<{ singleData: Translation, sections: Section[], items: any[]  }>()
);
export const fetchSingleRecordFail = createAction(
    '[Data] fetch single record translations failure', 
    props<{ error: string }>()
);


// Update Data
export const updateRecord = createAction(
    '[Data] Update record translations',
    props<{ id: string; section: string; updatedData: any }>()
);
export const updateRecordSuccess = createAction(
    '[Data] Update record translations success'
);
export const updateRecordFailure = createAction(
    '[Data] Update record translations failure',
    props<{ error: string }>()
);

//Reset State
export const resetState = createAction(
    '[Data] reset state translations',
);